import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CommonService } from 'huddyapi';
import { DesktopErrorHandler } from '../services/errorHandler.service';
import { DesktopStorageService } from '../services/storage.service';
import { TempAuthService } from '../services/tempAuthService';
import { AppComponent } from '../app.component';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  static loading: boolean = false;
  static returnURL: string = null;
  defaultRoute : string = 'PROFESSIONAL' ? 'patients' : 'work-queue';

  constructor(
    private errorHandler: DesktopErrorHandler,
    public commonService: CommonService,
    public router: Router,
    public storageService: DesktopStorageService,
    public authService: TempAuthService
  ) { 
  

  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    var hasJWTToken = CommonService.jwt != null;
    let validRole: boolean = false;
    const onboarding: boolean = !!CommonService.onboardingPersona || next.url[0].toString() == 'onboarding';
    if(onboarding)
      AuthGuard.returnURL = null;
    if(!hasJWTToken) {
      if(!onboarding)
        AuthGuard.returnURL = state.url;
      this.router.navigate(['']);
    } else {
      if(AuthGuard.returnURL) {
        const returnURL = AuthGuard.returnURL;
        AuthGuard.returnURL = null;
        this.router.navigateByUrl(returnURL);
        return false;
      }
      if(!(AuthGuard.loading || CommonService.getUser())) {
        AuthGuard.loading = true;
        this.authService.getAccount(CommonService.jwt).toPromise().then((user: any) => {
          CommonService.setUserAuth(CommonService.jwt, user.email, user);
          this.commonService.refreshCurrentUserToView();
          if(next.data && next.data.roles) {
            for(let auth of user.authorities) {
              if(next.data.roles.indexOf(auth) != -1)
                validRole = true;
            }
          } else if(!next.data.roles)
            validRole = true;
          if(!validRole)
            this.router.navigate([this.defaultRoute]);
          AuthGuard.loading = false;
        }, (error: any) => {
          this.errorHandler.handle(error, 'user');
        });
      } else if(CommonService.getUser()) {
        if(next.data && next.data.roles) {
          for(let auth of CommonService.getUser().authorities) {
            if(next.data.roles.indexOf(auth) != -1)
              validRole = true;
          }
        } else if(!next.data.roles)
          validRole = true;
        if(!validRole)
          this.router.navigate([this.defaultRoute]);
      }
    }
    return hasJWTToken;
  }
}
